<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
<div class="relative">
  <div class="vx-navbar-wrapper navbar-full p-0">
    <vs-navbar class="navbar-custom navbar-skelton pt-2 pb-2" :class="navbarClasses"  :style="navbarStyle" :color="navbarColor">


      <router-link tag="div" to="/" class="vx-logo cursor-pointer mr-auto flex items-left">
        <div class="logo-wrapper w-full flex flex-col text-left">
          <h1 class="arf-logo">
            <i class=" fa fa-leaf green"></i>
            <span class="green">O</span><span class="blue">yis</span>
          </h1>
        </div>
      </router-link>

      <div class="flex"> <ul class="menu-items flex flex-wrap w-full items-center">
        <li
          class  = "menu-item"
          v-for  = "(item, index) in navMenuItems"
          :key   = "index"
          v-if="!item.qualification || is_qualified"
          :class = "{'mr-2': !(navMenuItems.length === index+1)}">

          <!-- If header -->
          <template v-if="item.header">
            <h-nav-menu-header :header="item" class="menu-header relative" />
          </template>

          <!-- If it's group -->
          <template v-else-if="item.submenu">
            <h-nav-menu-group
              class="menu-group relative"
              bottom
              :key        ="`group-${index}`"
              :group      ="item"
              :groupIndex ="index"
              :open       ="checkGrpChildrenActive(item)" />
          </template>

          <!-- If it's link -->
          <div v-else-if="item.url" class="menu-link">
            <h-nav-menu-item
              class       = "relative cursor-pointer"
              :to         = "item.slug !== 'external' ? item.url : null"
              :href       = "item.slug === 'external' ? item.url : null"
              :icon       = "item.icon"
              :target     = "item.target"
              :isDisabled = "item.isDisabled"
              :slug       = "item.slug">
              <span class="truncate header-menu-font">{{ item.name }}</span>
              <vs-chip :color="item.tagColor" v-if="item.tag">{{ item.tag }}</vs-chip>
            </h-nav-menu-item>
          </div>

        </li>
      </ul>
      </div>
      <notification-drop-down :unread-notifications="event_data" />

      <div class="flex flex-col flex-grow-0 px-2">
        <span class="text-label">Alarm Modu</span>
        <vs-switch id="option" class="selected-switch" v-model="alarm_mode_local"/>
      </div>
      <profile-drop-down />

    </vs-navbar>
  </div>
</div>
</template>

<script>
import Bookmarks            from './components/Bookmarks.vue'
import SearchBar            from './components/SearchBar.vue'
import navMenuItems        from '@/layouts/components/vertical-nav-menu/navMenuItems.js'
import EditDropDown from './components/EditEventPopup.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import ProfileDropDown      from './components/ProfileDropDown.vue'
import Logo                 from '../Logo.vue'
import HNavMenuGroup from '../horizontal-nav-menu/HorizontalNavMenuGroup'
import HNavMenuHeader from '../horizontal-nav-menu/HorizontalNavMenuHeader'
import HNavMenuItem from '../horizontal-nav-menu/HorizontalNavMenuItem'

export default {
  name: 'the-navbar-horizontal',
  props: {
    logo: { type: String                                                                                                          },
    navbarType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      navMenuItems,
      alarm_mode_local: true
    }
  },
  watch: {
    alarm_mode_local () {
      this.$store.commit('SET_ALARM_MODE', this.alarm_mode_local)
    }
  },
  mounted () {
    this.alarm_mode_local = this.alarm_mode
  },
  components: {
    Logo,
    Bookmarks,
    navMenuItems,
    SearchBar,
    EditDropDown,
    ProfileDropDown,
    HNavMenuGroup,
    HNavMenuHeader,
    HNavMenuItem,
    NotificationDropDown
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    is_qualified () {
      return this.activeUserInfo.role === 'superadmin'
    },
    alarm_mode () {
      return this.$store.state.alarm_mode
    },
    event_data () {
      return this.$store.state.event_data.filter((event_) => {
        const event = event_.event
        if (event.status === 'None') {
          return event
        }
      })
    },
    navbarColor () {
      let color = '#2F3D40'
      if (this.navbarType === 'sticky') color = '#2F3D40'
      else if (this.navbarType === 'static') {
        if (this.scrollY < 50) {
          color = '#2F3D40'
        }
      }

      if (this.isThemedark === 'dark') {
        if (color === '#fff') {
          color = '#0e0f13'
        } else {
          color = '#14171c'
        }
      }

      return color
    },
    isThemedark ()          { return this.$store.state.theme                                                                       },
    navbarStyle ()          { return this.navbarType === 'static' ? {transition: 'all .25s ease-in-out'} : {}                      },
    navbarClasses ()        { return this.scrollY > 5 && this.navbarType === 'static' ? null : 'd-theme-dark-light-bg shadow-none' },
    scrollY ()              { return this.$store.state.scrollY                                                                     },
    verticalNavMenuWidth () { return this.$store.state.verticalNavMenuWidth                                                        },
    windowWidth ()          { return this.$store.state.windowWidth                                                                 }
  }
}

</script>

